(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["ott"] = factory();
	else
		root["pakhshkit"] = root["pakhshkit"] || {}, root["pakhshkit"]["providers"] = root["pakhshkit"]["providers"] || {}, root["pakhshkit"]["providers"]["ott"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 41);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _error = __webpack_require__(1);

var _error2 = _interopRequireDefault(_error);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var VIDIUN_HEADER_PREFIX = 'x-';

var RequestBuilder = function () {

  /**
   * @constructor
   * @param {Map<string, string>} headers The request headers
   */


  /**
   * @description hold the promise result of the XHR request(s) - if all tries fails, it rejects with the error.
   * @memberof RequestBuilder
   * @type {Object}
   * @private
   */

  /**
   * @description network retry configuration
   * @memberof RequestBuilder
   * @type {ProviderNetworkRetryParameters}
   */

  /**
   * @memberof - Service tag
   * @type {string}
   */

  /**
   * @memberof - Service URL
   * @type {string}
   */

  /**
   * @member - Service params
   * @type {any}
   */

  /**
   * @member - Service name
   * @type {string}
   */
  function RequestBuilder() {
    var headers = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new Map();

    _classCallCheck(this, RequestBuilder);

    this._attemptCounter = 1;

    this.headers = headers;
  }

  /**
   * Builds restful service URL
   * @function getUrl
   * @param {string} serviceUrl - The service base URL
   * @returns {string} The service URL
   */


  /**
   * @description number of xhr attempts for the same multi - request.
   * @memberof RequestBuilder
   * @type {number}
   * @private
   */

  /**
   * @memberof - the response headers of the arra
   * @type {Array<string>}
   */

  /**
   * @memberof - Service method (POST,GET,DELETE etc..)
   * @type {string}
   */

  /**
   * @memberof - Service headers
   * @type {Map<string, string>}
   */

  /**
   * @member - Service action
   * @type {string}
   */


  _createClass(RequestBuilder, [{
    key: 'getUrl',
    value: function getUrl(serviceUrl) {
      return serviceUrl + '/service/' + this.service + (this.action ? '/action/' + this.action : '');
    }

    /**
     * Executes service
     * @function doHttpRequest
     * @returns {Promise.<any>} Service response as promise
     */

  }, {
    key: 'doHttpRequest',
    value: function doHttpRequest() {
      var _this = this;

      var promise = new Promise(function (resolve, reject) {
        _this._requestPromise = {
          resolve: resolve,
          reject: reject
        };
      });
      if (!this.url) {
        this._requestPromise.reject(new _error2.default(_error2.default.Severity.CRITICAL, _error2.default.Category.NETWORK, _error2.default.Code.MALFORMED_DATA_URI, {
          url: this.url
        }));
      }
      this._createXHR();
      return promise;
    }
  }, {
    key: '_createXHR',
    value: function _createXHR() {
      var _this2 = this;

      var request = new XMLHttpRequest();
      request.onreadystatechange = function () {
        if (request.readyState === 4) {
          if (request.status === 200) {
            try {
              var response = JSON.parse(request.responseText);
              _this2.responseHeaders = _this2._getResponseHeaders(request);
              // the promise returns the response for backwards compatibility
              return _this2._requestPromise.resolve(response);
            } catch (error) {
              _this2._requestPromise.reject(_this2._createError(request, _error2.default.Code.BAD_SERVER_RESPONSE, {
                text: request.responseText
              }));
            }
          }
        }
      };
      request.open(this.method, this.url, this.retryConfig.async);
      if (this.retryConfig.async && this.retryConfig.timeout) {
        request.timeout = this.retryConfig.timeout;
      }
      var requestTime = performance.now();
      request.ontimeout = function () {
        _this2._handleError(request, _error2.default.Code.TIMEOUT, {
          timeout: (performance.now() - requestTime) / 1000,
          statusText: request.statusText
        });
      };
      request.onerror = request.onabort = function () {
        _this2._handleError(request, _error2.default.Code.HTTP_ERROR, {
          text: request.responseText,
          statusText: request.statusText
        });
      };
      this.headers.forEach(function (value, key) {
        request.setRequestHeader(key, value);
      });
      request.send(this.params);
    }
  }, {
    key: '_getResponseHeaders',
    value: function _getResponseHeaders(request) {
      return request.getAllResponseHeaders().split('\n').filter(function (header) {
        return header.toLowerCase().indexOf(VIDIUN_HEADER_PREFIX) === 0;
      });
    }
  }, {
    key: '_handleError',
    value: function _handleError(request, code, data) {
      var error = this._createError(request, code, data);
      request.onreadystatechange = function () {};
      request.onerror = function () {};
      request.ontimeout = function () {};
      request.onabort = function () {};
      if (this.retryConfig.maxAttempts && this._attemptCounter < this.retryConfig.maxAttempts) {
        this._attemptCounter++;
        this._createXHR();
      } else {
        return this._requestPromise.reject(error);
      }
    }
  }, {
    key: '_createError',
    value: function _createError(request, code, data) {
      Object.assign(data, {
        url: this.url,
        headers: this._getResponseHeaders(request),
        attempt: this._attemptCounter
      });
      return new _error2.default(_error2.default.Severity.CRITICAL, _error2.default.Category.NETWORK, code, data);
    }
  }]);

  return RequestBuilder;
}();

exports.default = RequestBuilder;

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _logger = __webpack_require__(2);

var _logger2 = _interopRequireDefault(_logger);

var _severity = __webpack_require__(23);

var _code = __webpack_require__(22);

var _category = __webpack_require__(21);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var CLASS_NAME = 'Error';

/**
 * @classdesc This is a description of the error class.
 */

var Error =

/**
 * @constructor
 * @param {number} severity - error's severity
 * @param {number} category - error's category.
 * @param {number} code - error's code.
 * @param {any} data - additional data for the error.
 */

/**
 * @enum {number}
 */

/**
 * @enum {number}
 */
function Error(severity, category, code) {
  var data = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

  _classCallCheck(this, Error);

  this.severity = severity;
  this.category = category;
  this.code = code;
  this.data = data;
  if ((0, _logger.getLogLevel)(CLASS_NAME) !== _logger.LogLevel.OFF) {
    Error._logger.error('Category:' + category + ' | Code:' + code + ' |', data);
  }
}
/**
 * @enum {number}
 */
;

Error.Severity = _severity.Severity;
Error.Category = _category.Category;
Error.Code = _code.Code;
Error._logger = (0, _logger2.default)(CLASS_NAME);
exports.default = Error;

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setLogLevel = exports.getLogLevel = exports.LogLevel = undefined;

var _jsLogger = __webpack_require__(27);

var JsLogger = _interopRequireWildcard(_jsLogger);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var LogLevel = {
  DEBUG: JsLogger.DEBUG,
  INFO: JsLogger.INFO,
  TIME: JsLogger.TIME,
  WARN: JsLogger.WARN,
  ERROR: JsLogger.ERROR,
  OFF: JsLogger.OFF
};


JsLogger.useDefaults({ defaultLevel: JsLogger.ERROR });

/**
 * get a logger
 * @param {?string} name - the logger name
 * @returns {Object} - the logger class
 */
function getLogger(name) {
  if (!name) {
    return JsLogger;
  }
  return JsLogger.get(name);
}

/**
 * get the log level
 * @param {?string} name - the logger name
 * @returns {LogLevelObject} - the log level
 */
function getLogLevel(name) {
  return getLogger(name).getLevel();
}

/**
 * sets the logger level
 * @param {LogLevelObject} level - the log level
 * @param {?string} name - the logger name
 * @returns {void}
 */
function setLogLevel(level, name) {
  getLogger(name).setLevel(level);
}

exports.default = getLogger;
exports.LogLevel = LogLevel;
exports.getLogLevel = getLogLevel;
exports.setLogLevel = setLogLevel;

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ServiceResult =

/**
 * @constructor
 * @param {Object} response - Service response
 */

/**
 * @member - The service error
 * @type {ServiceError}
 */

/**
 * @member - The service result data
 * @type {Object}
 */
function ServiceResult(response) {
  _classCallCheck(this, ServiceResult);

  this.hasError = false;

  if (response.objectType === 'VidiunAPIException') {
    this.hasError = true;
    this.error = new ServiceError(response.code, response.message);
  } else if (response.error && response.error.objectType === 'VidiunAPIException') {
    this.hasError = true;
    this.error = new ServiceError(response.error.code, response.error.message);
  } else {
    this.data = response;
  }
}
/**
 * @member - Is service returned an error
 * @type {boolean}
 */
;

exports.default = ServiceResult;

var ServiceError =

/**
 * @constructor
 * @param {string} code - The result code
 * @param {string} message - The result message
 */

/**
 * @member - The error code
 * @type {string}
 */
function ServiceError(code, message) {
  _classCallCheck(this, ServiceError);

  this.code = code;
  this.message = message;
}
/**
 * @member - The error message
 * @type {string}
 */
;

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _mediaSources = __webpack_require__(10);

var _mediaSources2 = _interopRequireDefault(_mediaSources);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var MediaEntry = function () {

  /**
   * @constructor
   */


  /**
   * @member - entry id
   * @type {string}
   */

  /**
   * @member - entry name
   * @type {string}
   */

  /**
   * @member - entry sources
   * @type {MediaSources}
   */

  /**
   * @member - entry duration
   * @type {number}
   */

  /**
   * @member - entry type
   * @type {string}
   */

  /**
   * @member - entry metadata
   * @type {Object}
   */

  /**
   * @member - DVR status
   * @type {number}
   */

  /**
   * @member - media poster
   * @type {string | Array<Object>}
   */


  /**
   * @member - assetReferenceType
   * @type {string }
   */
  function MediaEntry() {
    _classCallCheck(this, MediaEntry);

    this.metadata = new Map();
    this.sources = new _mediaSources2.default();
    this.type = MediaEntry.Type.UNKNOWN;
  }

  /**
   * Convert class to native js object.
   * @returns {ProviderMediaEntryObject} - The json class object.
   */


  _createClass(MediaEntry, [{
    key: 'toJSON',
    value: function toJSON() {
      return {
        id: this.id,
        name: this.name,
        sources: this.sources.toJSON(),
        duration: this.duration,
        dvrStatus: this.dvrStatus,
        metadata: this.metadata,
        type: this.type,
        poster: this.poster,
        assetReferenceType: this.assetReferenceType
      };
    }
  }]);

  return MediaEntry;
}();

MediaEntry.Type = {
  VOD: 'Vod',
  LIVE: 'Live',
  IMAGE: 'Image',
  AUDIO: 'Audio',
  UNKNOWN: 'Unknown'
};
exports.default = MediaEntry;

/***/ }),
/* 5 */,
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _baseServiceResult = __webpack_require__(3);

var _baseServiceResult2 = _interopRequireDefault(_baseServiceResult);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var VidiunAsset = function (_ServiceResult) {
  _inherits(VidiunAsset, _ServiceResult);

  /**
   * @constructor
   * @param {Object} response The response
   */

  /**
   * @member - The asset metas
   * @type {Array<Object>}
   */

  /**
   * @member - The asset name description
   * @type {string}
   */
  function VidiunAsset(response) {
    _classCallCheck(this, VidiunAsset);

    var _this = _possibleConstructorReturn(this, (VidiunAsset.__proto__ || Object.getPrototypeOf(VidiunAsset)).call(this, response));

    _this.name = '';
    _this.description = '';
    _this.tags = [];
    _this.metas = [];
    _this.pictures = [];

    if (!_this.hasError) {
      _this.id = response.id;
      _this.name = response.name;
      _this.description = response.description;
      _this.metas = _this._formatTagsMetas(response.metas);
      _this.tags = _this._formatTagsMetas(response.tags);
      _this.pictures = response.images;
    }
    return _this;
  }
  /**
   * @member - The asset images
   * @type {Array<any>}
   */

  /**
   * @member - The asset tags
   * @type {Array<Object>}
   */

  /**
   * @member - The asset name
   * @type {string}
   */

  /**
   * @member - The asset id
   * @type {number}
   */


  _createClass(VidiunAsset, [{
    key: '_formatTagsMetas',
    value: function _formatTagsMetas(objectToParse) {
      var parsed = [];
      Object.keys(objectToParse).forEach(function (key) {
        if (objectToParse[key].objects) {
          var value = '';
          objectToParse[key].objects.forEach(function (object) {
            value += object.value + '|';
          });
          parsed.push({ key: key, value: value });
        } else {
          parsed.push({ key: key, value: objectToParse[key].value });
        }
      });
      return parsed;
    }
  }]);

  return VidiunAsset;
}(_baseServiceResult2.default);

VidiunAsset.Type = {
  MEDIA: 'media',
  RECORDING: 'recording',
  EPG: 'epg'
};
VidiunAsset.AssetReferenceType = {
  MEDIA: 'media',
  EPG_INTERNAL: 'epg_internal',
  EPG_EXTERNAL: 'epg_external'
};
exports.default = VidiunAsset;

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Drm = function () {

  /**
   * @constructor
   * @param {string} licenseUrl - the license url
   * @param {string} scheme - the drm scheme
   * @param {?string} certificate - the drm certificate
   */

  /**
   * @member - drm scheme
   * @type {string}
   */
  function Drm(licenseUrl, scheme, certificate) {
    _classCallCheck(this, Drm);

    this.licenseUrl = licenseUrl;
    this.scheme = scheme;
    if (certificate) {
      this.certificate = certificate;
    }
  }

  /**
   * Convert class to native js object.
   * @returns {ProviderDrmDataObject} - The json class object.
   */


  /**
   * @member - drm certificate
   * @type {string}
   */

  /**
   * @member - license url
   * @type {string}
   */


  _createClass(Drm, [{
    key: "toJSON",
    value: function toJSON() {
      var response = {
        licenseUrl: this.licenseUrl,
        scheme: this.scheme
      };
      if (this.certificate) response.certificate = this.certificate;
      return response;
    }
  }]);

  return Drm;
}();

exports.default = Drm;

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var MediaFormat = exports.MediaFormat = {
  DASH: {
    name: 'dash',
    mimeType: 'application/dash+xml',
    pathExt: 'mpd'
  },
  HLS: {
    name: 'hls',
    mimeType: 'application/x-mpegURL',
    pathExt: 'm3u8'
  },
  WVM: {
    name: 'wvm',
    mimeType: 'video/wvm',
    pathExt: 'wvm'
  },
  MP4: {
    name: 'mp4',
    mimeType: 'video/mp4',
    pathExt: 'mp4'
  },
  MP3: {
    name: 'mp3',
    mimeType: 'audio/mpeg',
    pathExt: 'mp3'
  }
};

var SupportedStreamFormat = exports.SupportedStreamFormat = new Map([['mpegdash', MediaFormat.DASH], ['applehttp', MediaFormat.HLS], ['url', MediaFormat.MP4]]);

/**
 * returns a boolean whether a source is progressive or not
 * @param {string} formatName - the format name
 * @returns {boolean} - if source is progressive or not
 */
function isProgressiveSource(formatName) {
  var sourceFormat = SupportedStreamFormat.get(formatName);
  return !!sourceFormat && sourceFormat.name === MediaFormat.MP4.name;
}

exports.isProgressiveSource = isProgressiveSource;

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _drm = __webpack_require__(7);

var _drm2 = _interopRequireDefault(_drm);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var MediaSource = function () {
  function MediaSource() {
    _classCallCheck(this, MediaSource);
  }

  _createClass(MediaSource, [{
    key: 'toJSON',


    /**
     * Convert class to native js object.
     * @returns {ProviderMediaSourceObject} - The json class object.
     */

    /**
     * @member - media source height
     * @type {number}
     */

    /**
     * @member - media source bandwidth
     * @type {number}
     */

    /**
     * @member - media source mimetype
     * @type {string}
     */

    /**
     * @member - media source id
     * @type {string}
     */
    value: function toJSON() {
      var response = {
        id: this.id,
        url: this.url,
        mimetype: this.mimetype
      };
      if (this.bandwidth) response.bandwidth = this.bandwidth;
      if (this.width) response.width = this.width;
      if (this.height) response.height = this.height;
      if (this.label) response.label = this.label;
      if (this.drmData && this.drmData.length > 0) {
        response.drmData = [];
        this.drmData.forEach(function (d) {
          if (Array.isArray(response.drmData)) {
            response.drmData.push(d.toJSON());
          }
        });
      }
      return response;
    }
    /**
     * @member - media source label
     * @type {string}
     */

    /**
     * @member - media source width
     * @type {number}
     */

    /**
     * @member - media source drm data
     * @type {Array<Drm>}
     */

    /**
     * @member - media source url
     * @type {string}
     */

  }]);

  return MediaSource;
}();

exports.default = MediaSource;

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _mediaSource = __webpack_require__(9);

var _mediaSource2 = _interopRequireDefault(_mediaSource);

var _mediaFormat = __webpack_require__(8);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var MediaSources = function () {

  /**
   * @constructor
   */

  /**
   * Hls media sources container.
   * @type {Array<MediaSource>}
   * @public
   */

  /**
   * Progressive download media sources container.
   * @type {Array<MediaSource>}
   * @public
   */
  function MediaSources() {
    _classCallCheck(this, MediaSources);

    this.progressive = [];
    this.dash = [];
    this.hls = [];
  }

  /**
   * Maps the source to one of the containers according to his media format.
   * @param {MediaSource} source - The source to add to one of the containers.
   * @param {MediaFormat} mediaFormat - The media format of the source.
   * @returns {void}
   */

  /**
   * Dash media sources container.
   * @type {Array<MediaSource>}
   * @public
   */


  _createClass(MediaSources, [{
    key: 'map',
    value: function map(source, mediaFormat) {
      if (mediaFormat) {
        switch (mediaFormat.name) {
          case _mediaFormat.MediaFormat.MP4.name:
            this.progressive.push(source);
            break;
          case _mediaFormat.MediaFormat.DASH.name:
            this.dash.push(source);
            break;
          case _mediaFormat.MediaFormat.HLS.name:
            this.hls.push(source);
            break;
          default:
            break;
        }
      }
    }

    /**
     * Convert class to native js object.
     * @returns {ProviderMediaSourcesObject} - The json class object.
     */

  }, {
    key: 'toJSON',
    value: function toJSON() {
      var response = {
        progressive: [],
        dash: [],
        hls: []
      };
      this.progressive.forEach(function (p) {
        return response.progressive.push(p.toJSON());
      });
      this.hls.forEach(function (h) {
        return response.hls.push(h.toJSON());
      });
      this.dash.forEach(function (d) {
        return response.dash.push(d.toJSON());
      });
      return response;
    }
  }]);

  return MediaSources;
}();

exports.default = MediaSources;

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _multiRequestBuilder = __webpack_require__(12);

var _multiRequestBuilder2 = _interopRequireDefault(_multiRequestBuilder);

var _error = __webpack_require__(1);

var _error2 = _interopRequireDefault(_error);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var DataLoaderManager = function () {
  /**
   * @member - Loaders response map index
   * @type {Map<string,Array<number>>}
   * @private
   */
  function DataLoaderManager(networkRetryConfig) {
    _classCallCheck(this, DataLoaderManager);

    this._loadersResponseMap = new Map();
    this._loaders = new Map();

    this._networkRetryConfig = networkRetryConfig;
  }

  /**
   * Add loader too execution loaders map
   * @function
   * @param {Function} loader Loader to add
   * @param {Object} params Loader params
   * @returns {void}
   */

  /**
   * @member - Loaders to execute
   * @type {Map<string,Function>}
   * @private
   */

  /**
   * @member - Loaders multi request
   * @type {MultiRequestBuilder}
   * @protected
   */

  /**
   * @member - Loaders multi response
   * @type {MultiRequestResult}
   * @private
   */


  _createClass(DataLoaderManager, [{
    key: 'add',
    value: function add(loader, params) {
      var _this = this;

      var execution_loader = new loader(params);
      if (execution_loader.isValid()) {
        this._loaders.set(loader.id, execution_loader);
        // Get the start index from the multiReqeust before adding current execution_loader requests
        var startIndex = this._multiRequest.requests.length;
        // Get the requests
        var requests = execution_loader.requests;
        this._multiRequest.retryConfig = this._networkRetryConfig;
        // Add requests to muktiRequest queue
        requests.forEach(function (request) {
          _this._multiRequest.add(request);
        });
        // Create range array of current execution_loader requests
        var executionLoaderResponseMap = Array.from(new Array(requests.length), function (val, index) {
          return index + startIndex;
        });
        // Add to map
        this._loadersResponseMap.set(loader.id, executionLoaderResponseMap);
      }
    }

    /**
     * Get data from all loaders using multi request
     * @function
     * @returns {Promise} Promise
     */

  }, {
    key: 'fetchData',
    value: function fetchData() {
      var _this2 = this;

      return new Promise(function (resolve, reject) {
        _this2._multiRequest.execute().then(function (data) {
          _this2._multiResponse = data.response;
          var preparedData = _this2.prepareData(data.response);
          if (preparedData.success) {
            resolve(_this2._loaders);
          } else {
            reject(new _error2.default(_error2.default.Severity.CRITICAL, _error2.default.Category.NETWORK, _error2.default.Code.API_RESPONSE_MISMATCH, {
              headers: data.headers
            }));
          }
        }, function (err) {
          reject(err);
        });
      });
    }

    /**
     * Prepare fetched data
     * @function
     * @param {MultiRequestResult} response - The multi request result
     * @returns {Object} - The prepared data
     */

  }, {
    key: 'prepareData',
    value: function prepareData(response) {
      var _this3 = this;

      this._loaders.forEach(function (loader, name) {
        var loaderDataIndexes = _this3._loadersResponseMap.get(name);
        try {
          if (loaderDataIndexes && loaderDataIndexes.length > 0) {
            loader.response = response.results.slice(loaderDataIndexes[0], loaderDataIndexes[loaderDataIndexes.length - 1] + 1);
          }
        } catch (err) {
          return { success: false, error: err };
        }
      });
      return { success: true, data: this._loaders };
    }
  }]);

  return DataLoaderManager;
}();

exports.default = DataLoaderManager;

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MultiRequestResult = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _requestBuilder = __webpack_require__(0);

var _requestBuilder2 = _interopRequireDefault(_requestBuilder);

var _logger = __webpack_require__(2);

var _logger2 = _interopRequireDefault(_logger);

var _baseServiceResult = __webpack_require__(3);

var _baseServiceResult2 = _interopRequireDefault(_baseServiceResult);

var _error = __webpack_require__(1);

var _error2 = _interopRequireDefault(_error);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MultiRequestBuilder = function (_RequestBuilder) {
  _inherits(MultiRequestBuilder, _RequestBuilder);

  function MultiRequestBuilder() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, MultiRequestBuilder);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = MultiRequestBuilder.__proto__ || Object.getPrototypeOf(MultiRequestBuilder)).call.apply(_ref, [this].concat(args))), _this), _this.requests = [], _temp), _possibleConstructorReturn(_this, _ret);
  }
  /**
   * @memberof - MultiRequestBuilder
   * @type {Array<RequestBuilder>}
   */


  _createClass(MultiRequestBuilder, [{
    key: 'add',

    /**
     * Adds request to requests array
     * @function add
     * @param {RequestBuilder} request The request
     * @returns {MultiRequestBuilder} The multiRequest
     */
    value: function add(request) {
      this.requests.push(request);
      var requestParams = {};
      var serviceDef = { service: request.service, action: request.action };
      Object.assign(requestParams, _defineProperty({}, this.requests.length, Object.assign(serviceDef, request.params)));
      Object.assign(requestParams, this.params);
      this.params = requestParams;
      return this;
    }

    /**
     * Executes a multi request
     * @function execute
     * @returns {Promise} The multirequest execution promise
     */

  }, {
    key: 'execute',
    value: function execute() {
      var _this2 = this;

      return new Promise(function (resolve, reject) {
        try {
          _this2.params = JSON.stringify(_this2.params);
        } catch (err) {
          MultiRequestBuilder._logger.error('' + err.message);
          reject(new _error2.default(_error2.default.Severity.CRITICAL, _error2.default.Category.PROVIDER, _error2.default.Code.FAILED_PARSING_REQUEST, {
            error: err,
            params: _this2.params
          }));
        }
        _this2.doHttpRequest().then(function (data) {
          var multiRequestResult = new MultiRequestResult(data);
          if (multiRequestResult.success) {
            resolve({
              headers: _this2.responseHeaders,
              response: multiRequestResult
            });
          } else {
            reject(new _error2.default(_error2.default.Severity.CRITICAL, _error2.default.Category.NETWORK, _error2.default.Code.MULTIREQUEST_API_ERROR, {
              url: _this2.url,
              headers: _this2.responseHeaders,
              results: multiRequestResult.results
            }));
          }
        }, function (err) {
          reject(err);
        });
      });
    }
  }]);

  return MultiRequestBuilder;
}(_requestBuilder2.default);

MultiRequestBuilder._logger = (0, _logger2.default)('MultiRequestBuilder');
exports.default = MultiRequestBuilder;

var MultiRequestResult =
/**
 * @constructor
 * @param {Object} response data
 */
exports.MultiRequestResult = function MultiRequestResult(response) {
  var _this3 = this;

  _classCallCheck(this, MultiRequestResult);

  this.results = [];

  this.success = true;
  var responseArr = response.result ? response.result : response;
  responseArr.forEach(function (result) {
    var serviceResult = new _baseServiceResult2.default(result);
    _this3.results.push(serviceResult);
    if (serviceResult.hasError) {
      MultiRequestResult._logger.error('Service returned an error with error code: ' + serviceResult.error.code + ' and message: ' + serviceResult.error.message + '.');
      _this3.success = false;
      return;
    }
  });
}
/**
 * @memberof MultiRequestResult
 * @type {Object}
 */

/**
 * @memberof MultiRequestResult
 * @type {boolean}
 */
;

MultiRequestResult._logger = (0, _logger2.default)('MultiRequestResult');

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var VidiunAccessControlMessage =

/**
 * @constructor
 * @param {Object} data The json response
 */

/**
 * @member - The access control message
 * @type {string}
 */
function VidiunAccessControlMessage(data) {
  _classCallCheck(this, VidiunAccessControlMessage);

  this.message = data.message;
  this.code = data.code;
}
/**
 *  @member - The access control message code
 * @@type {string}
 */
;

exports.default = VidiunAccessControlMessage;

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var VidiunDrmPlaybackPluginData =

/**
 * @constructor
 * @param {Object} drm The json response
 */


/**
 * @member - The drm scheme
 * @type {string}
 */


/**
 * @member - The license URL
 * @type {string}
 */


/**
 * @member - The drm certificate
 * @type {?string}
 */
function VidiunDrmPlaybackPluginData(drm) {
  _classCallCheck(this, VidiunDrmPlaybackPluginData);

  this.scheme = drm.scheme;
  this.licenseURL = drm.licenseURL;
  this.certificate = drm.certificate;
};

VidiunDrmPlaybackPluginData.Scheme = {
  'drm.PLAYREADY_CENC': 'com.microsoft.playready',
  'drm.WIDEVINE_CENC': 'com.widevine.alpha',
  'fairplay.FAIRPLAY': 'com.apple.fairplay',
  WIDEVINE_CENC: 'com.widevine.alpha',
  PLAYREADY_CENC: 'com.microsoft.playready',
  FAIRPLAY: 'com.apple.fairplay'
};
exports.default = VidiunDrmPlaybackPluginData;

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OTTConfiguration = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _clone = __webpack_require__(20);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var defaultConfig = {
  serviceParams: {
    apiVersion: '4.7.1'
  }
};

var OTTConfiguration = function () {
  function OTTConfiguration() {
    _classCallCheck(this, OTTConfiguration);
  }

  _createClass(OTTConfiguration, null, [{
    key: 'set',
    value: function set(clientConfig) {
      if (clientConfig) {
        Object.assign(defaultConfig, clientConfig);
      }
    }
  }, {
    key: 'get',
    value: function get() {
      return (0, _clone.clone)(defaultConfig);
    }
  }]);

  return OTTConfiguration;
}();

exports.default = OTTConfiguration;
exports.OTTConfiguration = OTTConfiguration;

/***/ }),
/* 16 */,
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _baseServiceResult = __webpack_require__(3);

var _baseServiceResult2 = _interopRequireDefault(_baseServiceResult);

var _vidiunAccessControlMessage = __webpack_require__(13);

var _vidiunAccessControlMessage2 = _interopRequireDefault(_vidiunAccessControlMessage);

var _vidiunRuleAction = __webpack_require__(29);

var _vidiunRuleAction2 = _interopRequireDefault(_vidiunRuleAction);

var _vidiunPlaybackSource = __webpack_require__(28);

var _vidiunPlaybackSource2 = _interopRequireDefault(_vidiunPlaybackSource);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var VidiunPlaybackContext = function (_ServiceResult) {
  _inherits(VidiunPlaybackContext, _ServiceResult);

  /**
   * @constructor
   * @param {Object} response The response
   */

  /**
   * @member - Array of actions as received from the rules that invalidated
   * @type {Array<VidiunRuleAction>}
   */
  function VidiunPlaybackContext(response) {
    _classCallCheck(this, VidiunPlaybackContext);

    var _this = _possibleConstructorReturn(this, (VidiunPlaybackContext.__proto__ || Object.getPrototypeOf(VidiunPlaybackContext)).call(this, response));

    _this.sources = [];
    _this.actions = [];
    _this.messages = [];

    if (!_this.hasError) {
      var messages = response.messages;
      if (messages) {
        messages.map(function (message) {
          return _this.messages.push(new _vidiunAccessControlMessage2.default(message));
        });
      }
      var actions = response.actions;
      if (actions) {
        actions.map(function (action) {
          return _this.actions.push(new _vidiunRuleAction2.default(action));
        });
      }
      var sources = response.sources;
      if (sources) {
        sources.map(function (source) {
          return _this.sources.push(new _vidiunPlaybackSource2.default(source));
        });
      }
    }
    return _this;
  }
  /**
   * @member - Array of actions as received from the rules that invalidated
   * @type {Array<VidiunAccessControlMessage>}
   */

  /**
   * @member - The playback sources
   * @type {Array<VidiunPlaybackSource>}
   */


  _createClass(VidiunPlaybackContext, [{
    key: 'hasBlockAction',
    value: function hasBlockAction() {
      return this.getBlockAction() !== undefined;
    }
  }, {
    key: 'getBlockAction',
    value: function getBlockAction() {
      return this.actions.find(function (action) {
        return action.type === _vidiunRuleAction2.default.Type.BLOCK;
      });
    }
  }, {
    key: 'getErrorMessages',
    value: function getErrorMessages() {
      return this.messages;
    }
  }]);

  return VidiunPlaybackContext;
}(_baseServiceResult2.default);

VidiunPlaybackContext.Type = {
  TRAILER: 'TRAILER',
  CATCHUP: 'CATCHUP',
  START_OVER: 'START_OVER',
  PLAYBACK: 'PLAYBACK'
};
exports.default = VidiunPlaybackContext;

/***/ }),
/* 18 */,
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _mediaEntry = __webpack_require__(4);

var _mediaEntry2 = _interopRequireDefault(_mediaEntry);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var EntryList = function EntryList() {
  _classCallCheck(this, EntryList);

  this.items = [];
}
/**
 * @member - entry list items
 * @type {Array<MediaEntry>}
 */
;

exports.default = EntryList;

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var clone = function clone(data) {
  var node = void 0;
  if (Array.isArray(data)) {
    node = data.length > 0 ? data.slice(0) : [];
    node.forEach(function (e, i) {
      if ((typeof e === 'undefined' ? 'undefined' : _typeof(e)) === 'object' && e !== {} || Array.isArray(e) && e.length > 0) {
        node[i] = clone(e);
      }
    });
  } else if ((typeof data === 'undefined' ? 'undefined' : _typeof(data)) === 'object') {
    node = Object.assign({}, data);
    Object.keys(node).forEach(function (key) {
      if (_typeof(node[key]) === 'object' && node[key] !== {} || Array.isArray(node[key]) && node[key].length > 0) {
        node[key] = clone(node[key]);
      }
    });
  } else {
    node = data;
  }
  return node;
};

exports.clone = clone;

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});


var Category = {
  /** Errors from the network stack. */
  NETWORK: 1,
  SERVICE: 2,
  PROVIDER: 3
};
exports.Category = Category;

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});


var Code = {
  /**
   * A network request was made using an unsupported URI scheme.
   */
  UNSUPPORTED_SCHEME: 1000,

  /**
   * An HTTP network request returned an HTTP status that indicated a failure.
   */
  BAD_HTTP_STATUS: 1001,

  /**
   * An HTTP network request failed with an error, but not from the server.
   */
  HTTP_ERROR: 1002,

  /**
   * A network request timed out.
   */
  TIMEOUT: 1003,

  /**
   * A network request was made with a malformed data URI.
   */
  MALFORMED_DATA_URI: 1004,

  /**
   * The server responsded with 2xx response, but it couldn't be parsed
   */
  BAD_SERVER_RESPONSE: 1005,

  /**
   * The server response had a valid structure but contained an error from the API
   */
  MULTIREQUEST_API_ERROR: 1006,

  /**
   * The server response had a valid structure and valid API result, but it did not match the request
   */
  API_RESPONSE_MISMATCH: 1007,

  /**
   * The server responded with an error
   */
  ERROR: 2000,

  /**
   * The server responded with a block action
   */
  BLOCK_ACTION: 2001,

  /**
   * The server responded with a block action
   */
  MISSING_MANDATORY_PARAMS: 3000,

  /**
   * The server responded with empty sources objects (for HLS, Dash and progressive)
   */
  MISSING_PLAY_SOURCE: 3001
};

exports.Code = Code;

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});


var Severity = {
  /**
   * An error occurred, but the Player is attempting to recover from the error.
   *
   * If the Player cannot ultimately recover, it still may not throw a CRITICAL
   * error.  For example, retrying for a media segment will never result in
   * a CRITICAL error (the Player will just retry forever).
   */
  RECOVERABLE: 1,
  /**
   * A critical error that the library cannot recover from.  These usually cause
   * the Player to stop loading or updating.  A new manifest must be loaded
   * to reset the library.
   */
  CRITICAL: 2
};

exports.Severity = Severity;

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _logger = __webpack_require__(2);

var _dataLoaderManager = __webpack_require__(11);

var _dataLoaderManager2 = _interopRequireDefault(_dataLoaderManager);

var _error = __webpack_require__(1);

var _error2 = _interopRequireDefault(_error);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var BaseProvider = function () {
  _createClass(BaseProvider, [{
    key: 'partnerId',
    get: function get() {
      return this._partnerId;
    }
  }, {
    key: 'widgetId',
    get: function get() {
      return this._widgetId || '_' + this._partnerId;
    }
  }, {
    key: 'uiConfId',
    get: function get() {
      return this._uiConfId;
    }
  }, {
    key: 'vs',
    get: function get() {
      return this._vs;
    },
    set: function set(value) {
      this._vs = value;
    }
  }, {
    key: 'playerVersion',
    get: function get() {
      return this._playerVersion;
    }
  }, {
    key: 'isAnonymous',
    get: function get() {
      return this._isAnonymous;
    }
  }]);

  function BaseProvider(options, playerVersion) {
    _classCallCheck(this, BaseProvider);

    this._networkRetryConfig = {
      async: true,
      timeout: 0,
      maxAttempts: 4
    };

    this._partnerId = options.partnerId;
    this._widgetId = options.widgetId;
    this._uiConfId = options.uiConfId;
    this._isAnonymous = !options.vs;
    this._vs = options.vs || '';
    this._playerVersion = playerVersion;
    if (options.logLevel && this.LogLevel[options.logLevel]) {
      (0, _logger.setLogLevel)(this.LogLevel[options.logLevel]);
    }
  }

  // eslint-disable-next-line no-unused-vars


  _createClass(BaseProvider, [{
    key: 'getMediaConfig',
    value: function getMediaConfig(mediaInfo) {
      throw new TypeError('getMediaConfig method must be implement by the derived class');
    }

    // eslint-disable-next-line no-unused-vars

  }, {
    key: '_parseDataFromResponse',
    value: function _parseDataFromResponse(data) {
      throw new TypeError('_parseDataFromResponse method must be implement by the derived class');
    }
  }, {
    key: '_verifyHasSources',
    value: function _verifyHasSources(sources) {
      if (sources.hls.concat(sources.dash, sources.progressive).length === 0) {
        throw new _error2.default(_error2.default.Severity.CRITICAL, _error2.default.Category.SERVICE, _error2.default.Code.MISSING_PLAY_SOURCE, {
          action: '',
          messages: 'No play source for entry id: ' + sources.id
        });
      }
    }
  }, {
    key: 'getLogLevel',
    value: function getLogLevel(name) {
      return (0, _logger.getLogLevel)(name);
    }
  }, {
    key: 'setLogLevel',
    value: function setLogLevel(level, name) {
      (0, _logger.setLogLevel)(level, name);
    }
  }, {
    key: 'LogLevel',
    get: function get() {
      return _logger.LogLevel;
    }
  }]);

  return BaseProvider;
}();

exports.default = BaseProvider;

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _multiRequestBuilder = __webpack_require__(12);

var _multiRequestBuilder2 = _interopRequireDefault(_multiRequestBuilder);

var _config = __webpack_require__(15);

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var SERVICE_NAME = 'multirequest';

var OTTService = function () {
  function OTTService() {
    _classCallCheck(this, OTTService);
  }

  _createClass(OTTService, null, [{
    key: 'getMultiRequest',

    /**
     * Gets a new instance of MultiRequestBuilder with ott params
     * @function getMultiRequest
     * @param {string} vs The vs
     * @param {string} partnerId The partner ID
     * @returns {MultiRequestBuilder} The multi request builder
     * @static
     */
    value: function getMultiRequest(vs, partnerId) {
      var config = _config2.default.get();
      var ottParams = config.serviceParams;
      if (vs) {
        Object.assign(ottParams, { vs: vs });
      }
      if (partnerId) {
        Object.assign(ottParams, { partnerId: partnerId });
      }
      var headers = new Map();
      headers.set('Content-Type', 'application/json');
      var multiReq = new _multiRequestBuilder2.default(headers);
      multiReq.method = 'POST';
      multiReq.service = SERVICE_NAME;
      multiReq.url = multiReq.getUrl(config.serviceUrl);
      multiReq.params = ottParams;
      return multiReq;
    }
  }]);

  return OTTService;
}();

exports.default = OTTService;

/***/ }),
/* 26 */,
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * js-logger - http://github.com/jonnyreeves/js-logger
 * Jonny Reeves, http://jonnyreeves.co.uk/
 * js-logger may be freely distributed under the MIT license.
 */
(function (global) {
	"use strict";

	// Top level module for the global, static logger instance.
	var Logger = { };

	// For those that are at home that are keeping score.
	Logger.VERSION = "1.4.1";

	// Function which handles all incoming log messages.
	var logHandler;

	// Map of ContextualLogger instances by name; used by Logger.get() to return the same named instance.
	var contextualLoggersByNameMap = {};

	// Polyfill for ES5's Function.bind.
	var bind = function(scope, func) {
		return function() {
			return func.apply(scope, arguments);
		};
	};

	// Super exciting object merger-matron 9000 adding another 100 bytes to your download.
	var merge = function () {
		var args = arguments, target = args[0], key, i;
		for (i = 1; i < args.length; i++) {
			for (key in args[i]) {
				if (!(key in target) && args[i].hasOwnProperty(key)) {
					target[key] = args[i][key];
				}
			}
		}
		return target;
	};

	// Helper to define a logging level object; helps with optimisation.
	var defineLogLevel = function(value, name) {
		return { value: value, name: name };
	};

	// Predefined logging levels.
	Logger.DEBUG = defineLogLevel(1, 'DEBUG');
	Logger.INFO = defineLogLevel(2, 'INFO');
	Logger.TIME = defineLogLevel(3, 'TIME');
	Logger.WARN = defineLogLevel(4, 'WARN');
	Logger.ERROR = defineLogLevel(8, 'ERROR');
	Logger.OFF = defineLogLevel(99, 'OFF');

	// Inner class which performs the bulk of the work; ContextualLogger instances can be configured independently
	// of each other.
	var ContextualLogger = function(defaultContext) {
		this.context = defaultContext;
		this.setLevel(defaultContext.filterLevel);
		this.log = this.info;  // Convenience alias.
	};

	ContextualLogger.prototype = {
		// Changes the current logging level for the logging instance.
		setLevel: function (newLevel) {
			// Ensure the supplied Level object looks valid.
			if (newLevel && "value" in newLevel) {
				this.context.filterLevel = newLevel;
			}
		},
		
		// Gets the current logging level for the logging instance
		getLevel: function () {
			return this.context.filterLevel;
		},

		// Is the logger configured to output messages at the supplied level?
		enabledFor: function (lvl) {
			var filterLevel = this.context.filterLevel;
			return lvl.value >= filterLevel.value;
		},

		debug: function () {
			this.invoke(Logger.DEBUG, arguments);
		},

		info: function () {
			this.invoke(Logger.INFO, arguments);
		},

		warn: function () {
			this.invoke(Logger.WARN, arguments);
		},

		error: function () {
			this.invoke(Logger.ERROR, arguments);
		},

		time: function (label) {
			if (typeof label === 'string' && label.length > 0) {
				this.invoke(Logger.TIME, [ label, 'start' ]);
			}
		},

		timeEnd: function (label) {
			if (typeof label === 'string' && label.length > 0) {
				this.invoke(Logger.TIME, [ label, 'end' ]);
			}
		},

		// Invokes the logger callback if it's not being filtered.
		invoke: function (level, msgArgs) {
			if (logHandler && this.enabledFor(level)) {
				logHandler(msgArgs, merge({ level: level }, this.context));
			}
		}
	};

	// Protected instance which all calls to the to level `Logger` module will be routed through.
	var globalLogger = new ContextualLogger({ filterLevel: Logger.OFF });

	// Configure the global Logger instance.
	(function() {
		// Shortcut for optimisers.
		var L = Logger;

		L.enabledFor = bind(globalLogger, globalLogger.enabledFor);
		L.debug = bind(globalLogger, globalLogger.debug);
		L.time = bind(globalLogger, globalLogger.time);
		L.timeEnd = bind(globalLogger, globalLogger.timeEnd);
		L.info = bind(globalLogger, globalLogger.info);
		L.warn = bind(globalLogger, globalLogger.warn);
		L.error = bind(globalLogger, globalLogger.error);

		// Don't forget the convenience alias!
		L.log = L.info;
	}());

	// Set the global logging handler.  The supplied function should expect two arguments, the first being an arguments
	// object with the supplied log messages and the second being a context object which contains a hash of stateful
	// parameters which the logging function can consume.
	Logger.setHandler = function (func) {
		logHandler = func;
	};

	// Sets the global logging filter level which applies to *all* previously registered, and future Logger instances.
	// (note that named loggers (retrieved via `Logger.get`) can be configured independently if required).
	Logger.setLevel = function(level) {
		// Set the globalLogger's level.
		globalLogger.setLevel(level);

		// Apply this level to all registered contextual loggers.
		for (var key in contextualLoggersByNameMap) {
			if (contextualLoggersByNameMap.hasOwnProperty(key)) {
				contextualLoggersByNameMap[key].setLevel(level);
			}
		}
	};

	// Gets the global logging filter level
	Logger.getLevel = function() {
		return globalLogger.getLevel();
	};

	// Retrieve a ContextualLogger instance.  Note that named loggers automatically inherit the global logger's level,
	// default context and log handler.
	Logger.get = function (name) {
		// All logger instances are cached so they can be configured ahead of use.
		return contextualLoggersByNameMap[name] ||
			(contextualLoggersByNameMap[name] = new ContextualLogger(merge({ name: name }, globalLogger.context)));
	};

	// CreateDefaultHandler returns a handler function which can be passed to `Logger.setHandler()` which will
	// write to the window's console object (if present); the optional options object can be used to customise the
	// formatter used to format each log message.
	Logger.createDefaultHandler = function (options) {
		options = options || {};

		options.formatter = options.formatter || function defaultMessageFormatter(messages, context) {
			// Prepend the logger's name to the log message for easy identification.
			if (context.name) {
				messages.unshift("[" + context.name + "]");
			}
		};

		// Map of timestamps by timer labels used to track `#time` and `#timeEnd()` invocations in environments
		// that don't offer a native console method.
		var timerStartTimeByLabelMap = {};

		// Support for IE8+ (and other, slightly more sane environments)
		var invokeConsoleMethod = function (hdlr, messages) {
			Function.prototype.apply.call(hdlr, console, messages);
		};

		// Check for the presence of a logger.
		if (typeof console === "undefined") {
			return function () { /* no console */ };
		}

		return function(messages, context) {
			// Convert arguments object to Array.
			messages = Array.prototype.slice.call(messages);

			var hdlr = console.log;
			var timerLabel;

			if (context.level === Logger.TIME) {
				timerLabel = (context.name ? '[' + context.name + '] ' : '') + messages[0];

				if (messages[1] === 'start') {
					if (console.time) {
						console.time(timerLabel);
					}
					else {
						timerStartTimeByLabelMap[timerLabel] = new Date().getTime();
					}
				}
				else {
					if (console.timeEnd) {
						console.timeEnd(timerLabel);
					}
					else {
						invokeConsoleMethod(hdlr, [ timerLabel + ': ' +
							(new Date().getTime() - timerStartTimeByLabelMap[timerLabel]) + 'ms' ]);
					}
				}
			}
			else {
				// Delegate through to custom warn/error loggers if present on the console.
				if (context.level === Logger.WARN && console.warn) {
					hdlr = console.warn;
				} else if (context.level === Logger.ERROR && console.error) {
					hdlr = console.error;
				} else if (context.level === Logger.INFO && console.info) {
					hdlr = console.info;
				} else if (context.level === Logger.DEBUG && console.debug) {
					hdlr = console.debug;
				}

				options.formatter(messages, context);
				invokeConsoleMethod(hdlr, messages);
			}
		};
	};

	// Configure and example a Default implementation which writes to the `window.console` (if present).  The
	// `options` hash can be used to configure the default logLevel and provide a custom message formatter.
	Logger.useDefaults = function(options) {
		Logger.setLevel(options && options.defaultLevel || Logger.DEBUG);
		Logger.setHandler(Logger.createDefaultHandler(options));
	};

	// Export to popular environments boilerplate.
	if (true) {
		!(__WEBPACK_AMD_DEFINE_FACTORY__ = (Logger),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	}
	else if (typeof module !== 'undefined' && module.exports) {
		module.exports = Logger;
	}
	else {
		Logger._prevLogger = global.Logger;

		Logger.noConflict = function () {
			global.Logger = Logger._prevLogger;
			return Logger;
		};

		global.Logger = Logger;
	}
}(this));


/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _vidiunDrmPlaybackPluginData = __webpack_require__(14);

var _vidiunDrmPlaybackPluginData2 = _interopRequireDefault(_vidiunDrmPlaybackPluginData);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var VidiunPlaybackSource = function () {

  /**
   * @constructor
   * @param {Object} source The response
   */
  function VidiunPlaybackSource(source) {
    var _this = this;

    _classCallCheck(this, VidiunPlaybackSource);

    this.drm = [];

    this.format = source.format;
    this.adsPolicy = source.adsPolicy;
    this.adsParam = source.adsParam;
    this.duration = source.duration;
    this.url = source.url;
    this.type = source.type;
    this.fileId = source.id;
    this.protocols = source.protocols;
    if (source.drm) {
      source.drm.map(function (drm) {
        return _this.drm.push(new _vidiunDrmPlaybackPluginData2.default(drm));
      });
    }
  }

  /**
   * Checks if source has DRM data
   * @function hasDrmData
   * @returns {boolean} Is source has DRM
   */


  _createClass(VidiunPlaybackSource, [{
    key: 'hasDrmData',
    value: function hasDrmData() {
      return this.drm && this.drm.length > 0;
    }

    /**
     * Returns source desired protocol if supported
     * @param {string} protocol - the desired protocol for the source (base play url protocol)
     * @returns {string} - protocol if protocol is in the protocols list - if not empty string returned
     */

  }, {
    key: 'getProtocol',
    value: function getProtocol(protocol) {
      var returnValue = '';
      if (this.protocols && this.protocols.length > 0) {
        var protocolsArr = this.protocols.split(',');
        protocolsArr.forEach(function (p) {
          if (p === protocol) {
            returnValue = p;
          }
        });
      } else if (protocol === 'http') {
        return protocol;
      }
      return returnValue;
    }
  }]);

  return VidiunPlaybackSource;
}();

exports.default = VidiunPlaybackSource;

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var VidiunRuleAction =

/**
 * @constructor
 * @param {Object} data - The response
 */


/**
 * @member - The type of the action
 * @type {string|number}
 */
function VidiunRuleAction(data) {
  _classCallCheck(this, VidiunRuleAction);

  this.type = data.type;
};

VidiunRuleAction.Type = {
  BLOCK: 'BLOCK',
  START_DATE_OFFSET: 'START_DATE_OFFSET',
  END_DATE_OFFSET: 'END_DATE_OFFSET',
  USER_BLOCK: 'USER_BLOCK',
  ALLOW_PLAYBACK: 'ALLOW_PLAYBACK',
  BLOCK_PLAYBACK: 'BLOCK_PLAYBACK',
  APPLY_DISCOUNT_MODULE: 'APPLY_DISCOUNT_MODULE'
};
exports.default = VidiunRuleAction;

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _ottService = __webpack_require__(25);

var _ottService2 = _interopRequireDefault(_ottService);

var _requestBuilder = __webpack_require__(0);

var _requestBuilder2 = _interopRequireDefault(_requestBuilder);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SERVICE_NAME = 'asset';

var OTTAssetService = function (_OTTService) {
  _inherits(OTTAssetService, _OTTService);

  function OTTAssetService() {
    _classCallCheck(this, OTTAssetService);

    return _possibleConstructorReturn(this, (OTTAssetService.__proto__ || Object.getPrototypeOf(OTTAssetService)).apply(this, arguments));
  }

  _createClass(OTTAssetService, null, [{
    key: 'getPlaybackContext',

    /**
     * Creates an instance of RequestBuilder for session.startWidgetSession
     * @function anonymousSession
     * @param {string} serviceUrl The service base URL
     * @param {string} vs The partner ID
     * @param {string} assetId The asset ID
     * @param {string} type The asset type (media/recording/epg)
     * @param {ProviderPlaybackContextOptions} playbackContextOptions The playbackContextOptions
     * @returns {RequestBuilder} The request builder
     * @static
     */
    value: function getPlaybackContext(serviceUrl, vs, assetId, type, playbackContextOptions) {
      var headers = new Map();
      headers.set('Content-Type', 'application/json');
      var request = new _requestBuilder2.default(headers);
      request.service = SERVICE_NAME;
      request.action = 'getPlaybackContext';
      request.method = 'POST';
      request.url = request.getUrl(serviceUrl);
      var contextDataParams = { objectType: 'VidiunPlaybackContextOptions' };
      Object.assign(contextDataParams, playbackContextOptions);
      request.params = { assetId: assetId, assetType: type, contextDataParams: contextDataParams, vs: vs };
      return request;
    }
  }, {
    key: 'get',
    value: function get(serviceUrl, vs, assetId, assetReferenceType) {
      var headers = new Map();
      headers.set('Content-Type', 'application/json');
      var request = new _requestBuilder2.default(headers);
      request.service = SERVICE_NAME;
      request.action = 'get';
      request.method = 'POST';
      request.url = request.getUrl(serviceUrl);
      request.params = { id: assetId, assetReferenceType: assetReferenceType, vs: vs };
      return request;
    }
  }]);

  return OTTAssetService;
}(_ottService2.default);

exports.default = OTTAssetService;

/***/ }),
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _baseProvider = __webpack_require__(24);

var _baseProvider2 = _interopRequireDefault(_baseProvider);

var _logger = __webpack_require__(2);

var _logger2 = _interopRequireDefault(_logger);

var _config = __webpack_require__(15);

var _config2 = _interopRequireDefault(_config);

var _dataLoaderManager = __webpack_require__(44);

var _dataLoaderManager2 = _interopRequireDefault(_dataLoaderManager);

var _sessionLoader = __webpack_require__(45);

var _sessionLoader2 = _interopRequireDefault(_sessionLoader);

var _assetLoader = __webpack_require__(43);

var _assetLoader2 = _interopRequireDefault(_assetLoader);

var _assetListLoader = __webpack_require__(42);

var _assetListLoader2 = _interopRequireDefault(_assetListLoader);

var _providerParser = __webpack_require__(46);

var _providerParser2 = _interopRequireDefault(_providerParser);

var _vidiunAsset = __webpack_require__(6);

var _vidiunAsset2 = _interopRequireDefault(_vidiunAsset);

var _vidiunPlaybackContext = __webpack_require__(17);

var _vidiunPlaybackContext2 = _interopRequireDefault(_vidiunPlaybackContext);

var _mediaEntry = __webpack_require__(4);

var _mediaEntry2 = _interopRequireDefault(_mediaEntry);

var _error = __webpack_require__(1);

var _error2 = _interopRequireDefault(_error);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var OTTProvider = function (_BaseProvider) {
  _inherits(OTTProvider, _BaseProvider);

  /**
   * @constructor
   * @param {ProviderOptionsObject} options - provider options
   * @param {string} playerVersion - player version
   */
  function OTTProvider(options, playerVersion) {
    _classCallCheck(this, OTTProvider);

    var _this = _possibleConstructorReturn(this, (OTTProvider.__proto__ || Object.getPrototypeOf(OTTProvider)).call(this, options, playerVersion));

    _this._logger = (0, _logger2.default)('OTTProvider');
    _config2.default.set(options.env);
    _this._networkRetryConfig = Object.assign(_this._networkRetryConfig, options.networkRetryParameters);
    return _this;
  }

  /**
   * Gets the backend media config.
   * @param {OTTProviderMediaInfoObject} mediaInfo - ott media info
   * @returns {Promise<ProviderMediaConfigObject>} - The provider media config
   */


  _createClass(OTTProvider, [{
    key: 'getMediaConfig',
    value: function getMediaConfig(mediaInfo) {
      var _this2 = this;

      if (mediaInfo.vs) {
        this.vs = mediaInfo.vs;
        this._isAnonymous = false;
      }
      this._dataLoader = new _dataLoaderManager2.default(this.partnerId, this.vs, this._networkRetryConfig);
      return new Promise(function (resolve, reject) {
        var entryId = mediaInfo.entryId;
        if (entryId) {
          var vs = _this2.vs;
          if (!vs) {
            vs = '{1:result:vs}';
            _this2._dataLoader.add(_sessionLoader2.default, { partnerId: _this2.partnerId });
          }
          var contextType = mediaInfo.contextType || _vidiunPlaybackContext2.default.Type.PLAYBACK;
          var mediaType = mediaInfo.mediaType || _vidiunAsset2.default.Type.MEDIA;
          var assetReferenceType = mediaInfo.assetReferenceType || _vidiunAsset2.default.AssetReferenceType.MEDIA;
          var playbackContext = {
            mediaProtocol: mediaInfo.protocol,
            assetFileIds: mediaInfo.fileIds,
            context: contextType
          };
          _this2._dataLoader.add(_assetLoader2.default, {
            entryId: entryId,
            vs: vs,
            type: mediaType,
            playbackContext: playbackContext,
            assetReferenceType: assetReferenceType
          });
          var requestData = {
            contextType: contextType,
            mediaType: mediaType,
            formats: mediaInfo.formats || []
          };
          return _this2._dataLoader.fetchData().then(function (response) {
            try {
              resolve(_this2._parseDataFromResponse(response, requestData));
            } catch (err) {
              reject(err);
            }
          }, function (err) {
            reject(err);
          });
        } else {
          reject(new _error2.default(_error2.default.Severity.CRITICAL, _error2.default.Category.PROVIDER, _error2.default.Code.MISSING_MANDATORY_PARAMS, { message: 'missing entry id' }));
        }
      });
    }
  }, {
    key: '_parseDataFromResponse',
    value: function _parseDataFromResponse(data, requestData) {
      this._logger.debug('Data parsing started');
      var mediaConfig = {
        session: {
          isAnonymous: this._isAnonymous,
          partnerId: this.partnerId
        },
        sources: this._getDefaultSourcesObject(),
        plugins: {}
      };
      if (this.uiConfId) {
        mediaConfig.session.uiConfId = this.uiConfId;
      }
      if (data) {
        if (data.has(_sessionLoader2.default.id)) {
          var sessionLoader = data.get(_sessionLoader2.default.id);
          if (sessionLoader && sessionLoader.response) {
            mediaConfig.session.vs = sessionLoader.response;
          }
        } else {
          mediaConfig.session.vs = this.vs;
        }
        if (data.has(_assetLoader2.default.id)) {
          var assetLoader = data.get(_assetLoader2.default.id);
          if (assetLoader && assetLoader.response && Object.keys(assetLoader.response).length) {
            var response = assetLoader.response;
            if (_providerParser2.default.hasBlockAction(response)) {
              throw new _error2.default(_error2.default.Severity.CRITICAL, _error2.default.Category.SERVICE, _error2.default.Code.BLOCK_ACTION, {
                action: _providerParser2.default.getBlockAction(response),
                messages: _providerParser2.default.getErrorMessages(response)
              });
            }
            var mediaEntry = _providerParser2.default.getMediaEntry(response, requestData);
            Object.assign(mediaConfig.sources, this._getSourcesObject(mediaEntry));
            this._verifyHasSources(mediaConfig.sources);
          }
        }
      }
      this._logger.debug('Data parsing finished', mediaConfig);
      return mediaConfig;
    }

    /**
     * Gets playlist config from entry list.
     * @param {ProviderEntryListObject} entryListInfo - ott entry list info
     * @returns {Promise<ProviderPlaylistObject>} - The provider playlist config
     */

  }, {
    key: 'getEntryListConfig',
    value: function getEntryListConfig(entryListInfo) {
      var _this3 = this;

      if (entryListInfo.vs) {
        this.vs = entryListInfo.vs;
        this._isAnonymous = false;
      }
      this._dataLoader = new _dataLoaderManager2.default(this.partnerId, this.vs, this._networkRetryConfig);
      return new Promise(function (resolve, reject) {
        var entries = entryListInfo.entries;
        if (entries && entries.length) {
          var vs = _this3.vs;
          if (!vs) {
            vs = '{1:result:vs}';
            _this3._dataLoader.add(_sessionLoader2.default, { partnerId: _this3.partnerId });
          }
          _this3._dataLoader.add(_assetListLoader2.default, { entries: entries, vs: vs });
          _this3._dataLoader.fetchData().then(function (response) {
            resolve(_this3._parseEntryListDataFromResponse(response));
          }, function (err) {
            reject(err);
          });
        } else {
          reject({ success: false, data: 'Missing mandatory parameter' });
        }
      });
    }
  }, {
    key: '_parseEntryListDataFromResponse',
    value: function _parseEntryListDataFromResponse(data) {
      var _this4 = this;

      this._logger.debug('Data parsing started');
      var playlistConfig = {
        id: '',
        metadata: {
          name: '',
          description: ''
        },
        poster: '',
        items: []
      };
      if (data && data.has(_assetListLoader2.default.id)) {
        var playlistLoader = data.get(_assetListLoader2.default.id);
        if (playlistLoader && playlistLoader.response) {
          var entryList = _providerParser2.default.getEntryList(playlistLoader.response);
          entryList.items.forEach(function (i) {
            return playlistConfig.items.push({ sources: _this4._getSourcesObject(i) });
          });
        }
      }
      this._logger.debug('Data parsing finished', playlistConfig);
      return playlistConfig;
    }
  }, {
    key: '_getDefaultSourcesObject',
    value: function _getDefaultSourcesObject() {
      return {
        hls: [],
        dash: [],
        progressive: [],
        id: '',
        duration: 0,
        type: _mediaEntry2.default.Type.UNKNOWN,
        poster: '',
        dvr: false,
        vr: null,
        metadata: {
          name: '',
          description: '',
          tags: ''
        }
      };
    }
  }, {
    key: '_getSourcesObject',
    value: function _getSourcesObject(mediaEntry) {
      var sourcesObject = this._getDefaultSourcesObject();
      var mediaSources = mediaEntry.sources.toJSON();
      sourcesObject.hls = mediaSources.hls;
      sourcesObject.dash = mediaSources.dash;
      sourcesObject.progressive = mediaSources.progressive;
      sourcesObject.id = mediaEntry.id;
      sourcesObject.duration = mediaEntry.duration;
      sourcesObject.type = mediaEntry.type;
      sourcesObject.dvr = !!mediaEntry.dvrStatus;
      sourcesObject.poster = mediaEntry.poster;
      if (mediaEntry.metadata && mediaEntry.metadata.metas && typeof mediaEntry.metadata.metas.tags === 'string' && mediaEntry.metadata.metas.tags.indexOf('360') > -1) {
        sourcesObject.vr = {};
      }
      Object.assign(sourcesObject.metadata, mediaEntry.metadata);
      return sourcesObject;
    }
  }]);

  return OTTProvider;
}(_baseProvider2.default);

exports.default = OTTProvider;

/***/ }),
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VERSION = exports.NAME = exports.MediaType = exports.ContextType = exports.Provider = undefined;

var _provider = __webpack_require__(37);

var _provider2 = _interopRequireDefault(_provider);

var _vidiunPlaybackContext = __webpack_require__(17);

var _vidiunPlaybackContext2 = _interopRequireDefault(_vidiunPlaybackContext);

var _vidiunAsset = __webpack_require__(6);

var _vidiunAsset2 = _interopRequireDefault(_vidiunAsset);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NAME = "pakhshkit-js-providers" + '-ott';

var VERSION = "2.18.1";

var ContextType = _vidiunPlaybackContext2.default.Type;
var MediaType = _vidiunAsset2.default.Type;

exports.Provider = _provider2.default;
exports.ContextType = ContextType;
exports.MediaType = MediaType;
exports.NAME = NAME;
exports.VERSION = VERSION;

/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _requestBuilder = __webpack_require__(0);

var _requestBuilder2 = _interopRequireDefault(_requestBuilder);

var _config = __webpack_require__(15);

var _config2 = _interopRequireDefault(_config);

var _assetService = __webpack_require__(30);

var _assetService2 = _interopRequireDefault(_assetService);

var _vidiunAsset = __webpack_require__(6);

var _vidiunAsset2 = _interopRequireDefault(_vidiunAsset);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var OTTAssetListLoader = function () {
  _createClass(OTTAssetListLoader, null, [{
    key: 'id',
    get: function get() {
      return 'asset_list';
    }

    /**
     * @constructor
     * @param {Object} params loader params
     */

  }]);

  function OTTAssetListLoader(params) {
    _classCallCheck(this, OTTAssetListLoader);

    this._response = { playlistItems: { entries: [] } };

    this.requests = this.buildRequests(params);
    this._entries = params.entries;
  }

  _createClass(OTTAssetListLoader, [{
    key: 'buildRequests',


    /**
     * Builds loader requests
     * @function
     * @param {Object} params Requests parameters
     * @returns {RequestBuilder} The request builder
     * @static
     */
    value: function buildRequests(params) {
      var config = _config2.default.get();
      var requests = [];
      params.entries.forEach(function (entry) {
        var assetReferenceType = entry.assetReferenceType || _vidiunAsset2.default.AssetReferenceType.MEDIA;
        requests.push(_assetService2.default.get(config.serviceUrl, params.vs, entry.entryId || entry, assetReferenceType));
      });
      return requests;
    }

    /**
     * Loader validation function
     * @function
     * @returns {boolean} Is valid
     */

  }, {
    key: 'isValid',
    value: function isValid() {
      return !!(this._entries && this._entries.length);
    }
  }, {
    key: 'requests',
    set: function set(requests) {
      this._requests = requests;
    },
    get: function get() {
      return this._requests;
    }
  }, {
    key: 'response',
    set: function set(response) {
      var _this = this;

      response.forEach(function (item) {
        _this._response.playlistItems.entries.push({ mediaDataResult: new _vidiunAsset2.default(item.data) });
      });
    },
    get: function get() {
      return this._response;
    }
  }]);

  return OTTAssetListLoader;
}();

exports.default = OTTAssetListLoader;

/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _assetService = __webpack_require__(30);

var _assetService2 = _interopRequireDefault(_assetService);

var _config = __webpack_require__(15);

var _config2 = _interopRequireDefault(_config);

var _requestBuilder = __webpack_require__(0);

var _requestBuilder2 = _interopRequireDefault(_requestBuilder);

var _vidiunPlaybackContext = __webpack_require__(17);

var _vidiunPlaybackContext2 = _interopRequireDefault(_vidiunPlaybackContext);

var _vidiunAsset = __webpack_require__(6);

var _vidiunAsset2 = _interopRequireDefault(_vidiunAsset);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var OTTAssetLoader = function () {
  _createClass(OTTAssetLoader, null, [{
    key: 'id',
    get: function get() {
      return 'asset';
    }

    /**
     * @constructor
     * @param {Object} params loader params
     */

  }]);

  function OTTAssetLoader(params) {
    _classCallCheck(this, OTTAssetLoader);

    this._response = {};

    this.requests = this.buildRequests(params);
    this._entryId = params.entryId;
  }

  _createClass(OTTAssetLoader, [{
    key: 'buildRequests',


    /**
     * Builds loader requests
     * @function
     * @param {Object} params Requests parameters
     * @returns {RequestBuilder} The request builder
     * @static
     */
    value: function buildRequests(params) {
      var config = _config2.default.get();
      var requests = [];
      requests.push(_assetService2.default.get(config.serviceUrl, params.vs, params.entryId, params.assetReferenceType));
      requests.push(_assetService2.default.getPlaybackContext(config.serviceUrl, params.vs, params.entryId, params.type, params.playbackContext));
      return requests;
    }

    /**
     * Loader validation function
     * @function
     * @returns {boolean} Is valid
     */

  }, {
    key: 'isValid',
    value: function isValid() {
      return !!this._entryId;
    }
  }, {
    key: 'requests',
    set: function set(requests) {
      this._requests = requests;
    },
    get: function get() {
      return this._requests;
    }
  }, {
    key: 'response',
    set: function set(response) {
      this._response.mediaDataResult = new _vidiunAsset2.default(response[0].data);
      this._response.playBackContextResult = new _vidiunPlaybackContext2.default(response[1].data);
    },
    get: function get() {
      return this._response;
    }
  }]);

  return OTTAssetLoader;
}();

exports.default = OTTAssetLoader;

/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _dataLoaderManager = __webpack_require__(11);

var _dataLoaderManager2 = _interopRequireDefault(_dataLoaderManager);

var _ottService = __webpack_require__(25);

var _ottService2 = _interopRequireDefault(_ottService);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * OTTDataLoaderManager is a class that handles the OTT data loading
 * @param {string} partnerId - partner id
 * @param {string} vs - vs
 * @param {ProviderNetworkRetryParameters} [networkRetryConfig] - network retry configuration
 */
var OTTDataLoaderManager = function (_DataLoaderManager) {
  _inherits(OTTDataLoaderManager, _DataLoaderManager);

  function OTTDataLoaderManager(partnerId) {
    var vs = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    var networkRetryConfig = arguments[2];

    _classCallCheck(this, OTTDataLoaderManager);

    var _this = _possibleConstructorReturn(this, (OTTDataLoaderManager.__proto__ || Object.getPrototypeOf(OTTDataLoaderManager)).call(this, networkRetryConfig));

    _this._multiRequest = _ottService2.default.getMultiRequest(vs, partnerId);
    return _this;
  }

  return OTTDataLoaderManager;
}(_dataLoaderManager2.default);

exports.default = OTTDataLoaderManager;

/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _userService = __webpack_require__(47);

var _userService2 = _interopRequireDefault(_userService);

var _config = __webpack_require__(15);

var _config2 = _interopRequireDefault(_config);

var _requestBuilder = __webpack_require__(0);

var _requestBuilder2 = _interopRequireDefault(_requestBuilder);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var OTTSessionLoader = function () {
  _createClass(OTTSessionLoader, null, [{
    key: 'id',
    get: function get() {
      return 'session';
    }

    /**
     * @constructor
     * @param {Object} params loader params
     */

  }]);

  function OTTSessionLoader(params) {
    _classCallCheck(this, OTTSessionLoader);

    this._response = {};

    this.requests = this.buildRequests(params);
    this._partnerId = params.partnerId;
  }

  _createClass(OTTSessionLoader, [{
    key: 'buildRequests',


    /**
     * Builds loader requests
     * @function
     * @param {Object} params Requests parameters
     * @returns {RequestBuilder} The request builder
     * @static
     */
    value: function buildRequests(params) {
      var config = _config2.default.get();
      var requests = [];
      requests.push(_userService2.default.anonymousLogin(config.serviceUrl, params.partnerId, params.udid));
      return requests;
    }

    /**
     * Loader validation function
     * @function
     * @returns {boolean} Is valid
     */

  }, {
    key: 'isValid',
    value: function isValid() {
      return !!this._partnerId;
    }
  }, {
    key: 'requests',
    set: function set(requests) {
      this._requests = requests;
    },
    get: function get() {
      return this._requests;
    }
  }, {
    key: 'response',
    set: function set(response) {
      this._response.vs = response[0].data.vs;
    },
    get: function get() {
      return this._response.vs;
    }
  }]);

  return OTTSessionLoader;
}();

exports.default = OTTSessionLoader;

/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _VidiunAsset$Type$MED, _VidiunAsset$Type$EPG, _MediaTypeCombination;

var _logger = __webpack_require__(2);

var _logger2 = _interopRequireDefault(_logger);

var _vidiunPlaybackSource = __webpack_require__(28);

var _vidiunPlaybackSource2 = _interopRequireDefault(_vidiunPlaybackSource);

var _vidiunPlaybackContext = __webpack_require__(17);

var _vidiunPlaybackContext2 = _interopRequireDefault(_vidiunPlaybackContext);

var _vidiunAsset = __webpack_require__(6);

var _vidiunAsset2 = _interopRequireDefault(_vidiunAsset);

var _mediaEntry = __webpack_require__(4);

var _mediaEntry2 = _interopRequireDefault(_mediaEntry);

var _drm = __webpack_require__(7);

var _drm2 = _interopRequireDefault(_drm);

var _mediaSource = __webpack_require__(9);

var _mediaSource2 = _interopRequireDefault(_mediaSource);

var _mediaSources = __webpack_require__(10);

var _mediaSources2 = _interopRequireDefault(_mediaSources);

var _entryList = __webpack_require__(19);

var _entryList2 = _interopRequireDefault(_entryList);

var _mediaFormat = __webpack_require__(8);

var _vidiunDrmPlaybackPluginData = __webpack_require__(14);

var _vidiunDrmPlaybackPluginData2 = _interopRequireDefault(_vidiunDrmPlaybackPluginData);

var _vidiunRuleAction = __webpack_require__(29);

var _vidiunRuleAction2 = _interopRequireDefault(_vidiunRuleAction);

var _vidiunAccessControlMessage = __webpack_require__(13);

var _vidiunAccessControlMessage2 = _interopRequireDefault(_vidiunAccessControlMessage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var LIVE_ASST_OBJECT_TYPE = 'VidiunLiveAsset';

var MediaTypeCombinations = (_MediaTypeCombination = {}, _defineProperty(_MediaTypeCombination, _vidiunAsset2.default.Type.MEDIA, (_VidiunAsset$Type$MED = {}, _defineProperty(_VidiunAsset$Type$MED, _vidiunPlaybackContext2.default.Type.TRAILER, function () {
  return { type: _mediaEntry2.default.Type.VOD };
}), _defineProperty(_VidiunAsset$Type$MED, _vidiunPlaybackContext2.default.Type.PLAYBACK, function (mediaAssetData) {
  if (parseInt(mediaAssetData.externalIds) > 0 || mediaAssetData.objectType === LIVE_ASST_OBJECT_TYPE) {
    return { type: _mediaEntry2.default.Type.LIVE, dvrStatus: 0 };
  }
  return { type: _mediaEntry2.default.Type.VOD };
}), _VidiunAsset$Type$MED)), _defineProperty(_MediaTypeCombination, _vidiunAsset2.default.Type.EPG, (_VidiunAsset$Type$EPG = {}, _defineProperty(_VidiunAsset$Type$EPG, _vidiunPlaybackContext2.default.Type.CATCHUP, function () {
  return { type: _mediaEntry2.default.Type.VOD };
}), _defineProperty(_VidiunAsset$Type$EPG, _vidiunPlaybackContext2.default.Type.START_OVER, function () {
  return { type: _mediaEntry2.default.Type.LIVE, dvrStatus: 1 };
}), _VidiunAsset$Type$EPG)), _defineProperty(_MediaTypeCombination, _vidiunAsset2.default.Type.RECORDING, _defineProperty({}, _vidiunPlaybackContext2.default.Type.PLAYBACK, function () {
  return { type: _mediaEntry2.default.Type.VOD };
})), _MediaTypeCombination);

var OTTProviderParser = function () {
  function OTTProviderParser() {
    _classCallCheck(this, OTTProviderParser);
  }

  _createClass(OTTProviderParser, null, [{
    key: 'getMediaEntry',


    /**
     * Returns parsed media entry by given OTT response objects.
     * @function getMediaEntry
     * @param {any} assetResponse - The asset response.
     * @param {Object} requestData - The request data object.
     * @returns {MediaEntry} - The media entry
     * @static
     * @public
     */
    value: function getMediaEntry(assetResponse, requestData) {
      var mediaEntry = new _mediaEntry2.default();
      OTTProviderParser._fillBaseData(mediaEntry, assetResponse);
      var playbackContext = assetResponse.playBackContextResult;
      var mediaAsset = assetResponse.mediaDataResult;
      var vidiunSources = playbackContext.sources;
      var filteredVidiunSources = OTTProviderParser._filterSourcesByFormats(vidiunSources, requestData.formats);
      mediaEntry.sources = OTTProviderParser._getParsedSources(filteredVidiunSources);
      var typeData = OTTProviderParser._getMediaType(mediaAsset.data, requestData.mediaType, requestData.contextType);
      mediaEntry.type = typeData.type;
      mediaEntry.dvrStatus = typeData.dvrStatus;
      mediaEntry.duration = Math.max.apply(Math, vidiunSources.map(function (source) {
        return source.duration;
      }));
      return mediaEntry;
    }

    /**
     * Returns parsed entry list by given OTT response objects
     * @function getEntryList
     * @param {any} playlistResponse - response
     * @returns {Playlist} - The entry list
     * @static
     * @public
     */

  }, {
    key: 'getEntryList',
    value: function getEntryList(playlistResponse) {
      var entryList = new _entryList2.default();
      var playlistItems = playlistResponse.playlistItems.entries;
      playlistItems.forEach(function (entry) {
        var mediaEntry = new _mediaEntry2.default();
        OTTProviderParser._fillBaseData(mediaEntry, entry);
        entryList.items.push(mediaEntry);
      });
      return entryList;
    }
  }, {
    key: '_fillBaseData',
    value: function _fillBaseData(mediaEntry, assetResponse) {
      var mediaAsset = assetResponse.mediaDataResult;
      var metaData = OTTProviderParser.reconstructMetadata(mediaAsset);
      metaData.description = mediaAsset.description;
      metaData.name = mediaAsset.name;
      mediaEntry.metadata = metaData;
      mediaEntry.poster = OTTProviderParser._getPoster(mediaAsset.pictures);
      mediaEntry.id = mediaAsset.id;
      return mediaEntry;
    }

    /**
     * reconstruct the metadata
     * @param {Object} mediaAsset the mediaAsset that contains the response with the metadata.
     * @returns {Object} reconstructed metadata object
     */

  }, {
    key: 'reconstructMetadata',
    value: function reconstructMetadata(mediaAsset) {
      var metadata = {
        metas: OTTProviderParser.addToMetaObject(mediaAsset.metas),
        tags: OTTProviderParser.addToMetaObject(mediaAsset.tags)
      };
      return metadata;
    }

    /**
     * transform an array of [{key: value},{key: value}...] to an object
     * @param {Array<Object>} list a list of objects
     * @returns {Object} an mapped object of the arrayed list.
     */

  }, {
    key: 'addToMetaObject',
    value: function addToMetaObject(list) {
      var categoryObj = {};
      if (list) {
        list.forEach(function (item) {
          categoryObj[item.key] = item.value;
        });
      }
      return categoryObj;
    }

    /**
     * Gets the poster url without width and height.
     * @param {Array<Object>} pictures - Media pictures.
     * @returns {string | Array<Object>} - Poster base url or array of poster candidates.
     * @private
     */

  }, {
    key: '_getPoster',
    value: function _getPoster(pictures) {
      if (pictures && pictures.length > 0) {
        var picObj = pictures[0];
        var url = picObj.url;
        // Search for thumbnail service
        var regex = /.*\/thumbnail\/.*(?:width|height)\/\d+\/(?:height|width)\/\d+/;
        if (regex.test(url)) {
          return url;
        }
        return pictures.map(function (pic) {
          return { url: pic.url, width: pic.width, height: pic.height };
        });
      }
      return '';
    }

    /**
     * Gets the media type (LIVE/VOD)
     * @param {Object} mediaAssetData - The media asset data.
     * @param {string} mediaType - The asset media type.
     * @param {string} contextType - The asset context type.
     * @returns {Object} - The type data object.
     * @private
     */

  }, {
    key: '_getMediaType',
    value: function _getMediaType(mediaAssetData, mediaType, contextType) {
      var typeData = { type: _mediaEntry2.default.Type.UNKNOWN };
      if (MediaTypeCombinations[mediaType] && MediaTypeCombinations[mediaType][contextType]) {
        typeData = MediaTypeCombinations[mediaType][contextType](mediaAssetData);
      }
      return typeData;
    }

    /**
     * Filtered the vidiunSources array by device type.
     * @param {Array<VidiunPlaybackSource>} vidiunSources - The vidiun sources.
     * @param {Array<string>} formats - Partner device formats.
     * @returns {Array<VidiunPlaybackSource>} - Filtered vidiunSources array.
     * @private
     */

  }, {
    key: '_filterSourcesByFormats',
    value: function _filterSourcesByFormats(vidiunSources, formats) {
      if (formats.length > 0) {
        vidiunSources = vidiunSources.filter(function (source) {
          return formats.includes(source.type);
        });
      }
      return vidiunSources;
    }

    /**
     * Returns the parsed sources
     * @function _getParsedSources
     * @param {Array<VidiunPlaybackSource>} vidiunSources - The vidiun sources
     * @param {Object} playbackContext - The playback context
     * @return {MediaSources} - A media sources
     * @static
     * @private
     */

  }, {
    key: '_getParsedSources',
    value: function _getParsedSources(vidiunSources) {
      var sources = new _mediaSources2.default();
      var addAdaptiveSource = function addAdaptiveSource(source) {
        var parsedSource = OTTProviderParser._parseAdaptiveSource(source);
        if (parsedSource) {
          var sourceFormat = _mediaFormat.SupportedStreamFormat.get(source.format);
          sources.map(parsedSource, sourceFormat);
        }
      };
      var parseAdaptiveSources = function parseAdaptiveSources() {
        vidiunSources.filter(function (source) {
          return !(0, _mediaFormat.isProgressiveSource)(source.format);
        }).forEach(addAdaptiveSource);
      };
      var parseProgressiveSources = function parseProgressiveSources() {
        vidiunSources.filter(function (source) {
          return (0, _mediaFormat.isProgressiveSource)(source.format);
        }).forEach(addAdaptiveSource);
      };
      if (vidiunSources && vidiunSources.length > 0) {
        parseAdaptiveSources();
        parseProgressiveSources();
      }
      return sources;
    }

    /**
     * Returns a parsed adaptive source
     * @function _parseAdaptiveSource
     * @param {VidiunPlaybackSource} vidiunSource - A vidiun source
     * @returns {?MediaSource} - The parsed adaptive vidiunSource
     * @static
     * @private
     */

  }, {
    key: '_parseAdaptiveSource',
    value: function _parseAdaptiveSource(vidiunSource) {
      var mediaSource = new _mediaSource2.default();
      if (vidiunSource) {
        var playUrl = vidiunSource.url;
        var mediaFormat = _mediaFormat.SupportedStreamFormat.get(vidiunSource.format);
        if (mediaFormat) {
          mediaSource.mimetype = mediaFormat.mimeType;
        }
        if (!playUrl) {
          OTTProviderParser._logger.error('failed to create play url from source, discarding source: (' + vidiunSource.fileId + '), ' + vidiunSource.format + '.');
          return null;
        }
        mediaSource.url = playUrl;
        mediaSource.id = vidiunSource.fileId + ',' + vidiunSource.format;
        if (vidiunSource.hasDrmData()) {
          var drmParams = [];
          vidiunSource.drm.forEach(function (drm) {
            drmParams.push(new _drm2.default(drm.licenseURL, _vidiunDrmPlaybackPluginData2.default.Scheme[drm.scheme], drm.certificate));
          });
          mediaSource.drmData = drmParams;
        }
      }
      return mediaSource;
    }
  }, {
    key: 'hasBlockAction',
    value: function hasBlockAction(response) {
      return response.playBackContextResult.hasBlockAction();
    }
  }, {
    key: 'getBlockAction',
    value: function getBlockAction(response) {
      return response.playBackContextResult.getBlockAction();
    }
  }, {
    key: 'getErrorMessages',
    value: function getErrorMessages(response) {
      return response.playBackContextResult.getErrorMessages();
    }
  }]);

  return OTTProviderParser;
}();

OTTProviderParser._logger = (0, _logger2.default)('OTTProviderParser');
exports.default = OTTProviderParser;

/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _ottService = __webpack_require__(25);

var _ottService2 = _interopRequireDefault(_ottService);

var _requestBuilder = __webpack_require__(0);

var _requestBuilder2 = _interopRequireDefault(_requestBuilder);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SERVICE_NAME = 'ottuser';

var OTTUserService = function (_OTTService) {
  _inherits(OTTUserService, _OTTService);

  function OTTUserService() {
    _classCallCheck(this, OTTUserService);

    return _possibleConstructorReturn(this, (OTTUserService.__proto__ || Object.getPrototypeOf(OTTUserService)).apply(this, arguments));
  }

  _createClass(OTTUserService, null, [{
    key: 'anonymousLogin',

    /**
     * Creates an instance of RequestBuilder for session.startWidgetSession
     * @function anonymousSession
     * @param {string} serviceUrl The service base URL
     * @param {string} partnerId The partner ID
     * @param {string} udid The udid
     * @returns {RequestBuilder} The request builder
     * @static
     */
    value: function anonymousLogin(serviceUrl, partnerId, udid) {
      var headers = new Map();
      headers.set('Content-Type', 'application/json');
      var request = new _requestBuilder2.default(headers);
      request.service = SERVICE_NAME;
      request.action = 'anonymousLogin';
      request.method = 'POST';
      request.url = request.getUrl(serviceUrl);
      var params = { partnerId: partnerId };
      if (udid) {
        Object.assign(params, { udid: udid });
      }
      request.params = params;
      return request;
    }
  }]);

  return OTTUserService;
}(_ottService2.default);

exports.default = OTTUserService;

/***/ })
/******/ ]);
});


// WEBPACK FOOTER //
// pakhshkit-ott-provider.js


// WEBPACK FOOTER //
// providers/pakhshkit-ott-provider.js